module.exports = __webpack_public_path__ + "media/images/salomon_banner/banner__sidebar-b19ec09d68e1eb395c98865e867bba46.jpg";